import { Menu } from 'antd';
import SubMenu from 'antd/es/menu/SubMenu';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { styled } from 'styled-components';

import { MdPriceChange, MdSubscriptions, MdPayment } from 'react-icons/md';
import { FaFlagCheckered, FaUserAlt, FaRupeeSign, FaProductHunt, FaCalendarDay, FaUserCog, FaUsersCog, FaUserCircle } from 'react-icons/fa';
import { GiReceiveMoney } from 'react-icons/gi';
import { AiOutlineStock } from 'react-icons/ai';
import { TbZoomMoney } from 'react-icons/tb';

const SideNav = () => {
    const [openKeys, setOpenKeys] = useState([]);

    const openChangeHandler = (open_keys) => {
        const latestOpenKey = open_keys.slice(-1); // returns array with last element
        setOpenKeys(latestOpenKey);
    }

    return (
        <Wrapper>
            <Menu 
                mode="inline"
                // inlineIndent={0}
                openKeys={openKeys}
                defaultOpenKeys={['0', '3']}
                onOpenChange={openChangeHandler}
                style={{
                    background: '#1C79BB',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '15px',
                    maxHeight: 'calc(100vh - 10rem)',
                    overflowY: 'auto',
                }}
            >
                <SubMenu key='x' title="Market Place" icon={<MdPriceChange size='25px' style={{marginRight: '1rem'}}/>}>
                    <Menu.Item key='0'>
                        <NavLink to='' className='link'>Market Price</NavLink>
                    </Menu.Item>
                    <Menu.Item key='1'>
                        <NavLink to='primary-cd' className='link'>Primary CD</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='41' title="Non-SLR" icon={<TbZoomMoney size='20px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='42'>
                        <NavLink to='nonslr-money-market' className='link'>Non-SLR Money Market</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='39' title="NCD Data" icon={<AiOutlineStock size='20px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='40'>
                        <NavLink to='ncd-data-list' className='link'>NCD Table</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='2' title="Country" icon={<FaFlagCheckered size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='3'>
                        <NavLink to='country-form?mode=ADD' className='link'>Add Country</NavLink>
                    </Menu.Item>
                    <Menu.Item key='4'>
                        <NavLink to='country-list' className='link'>List Country</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='5' title="Customer" icon={<FaUserCircle size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='6'>
                        <NavLink to='customer-form?mode=ADD' className='link'>Add Customer</NavLink>
                    </Menu.Item>
                    <Menu.Item key='7'>
                        <NavLink to='customer-list' className='link'>List Customers</NavLink>
                    </Menu.Item>
                </SubMenu>
                
                <SubMenu key='8' title="Issuer" icon={<GiReceiveMoney size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='9'>
                        <NavLink to='issuer-form?mode=ADD' className='link'> Add Issuer</NavLink>
                    </Menu.Item>
                    <Menu.Item key='10'>
                        <NavLink to='issuer-list' className='link'>List Issuer</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='11' title="Currency" icon={<FaRupeeSign size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='12'>
                        <NavLink to='currency-form?mode=ADD' className='link'>Add Currency</NavLink>
                    </Menu.Item>
                    <Menu.Item key='13'>
                        <NavLink to='currency-list' className='link'>List Currency</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='14' title="Product" icon={<FaProductHunt size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='15'>
                        <NavLink to='product-form?mode=ADD' className='link'>Add Product</NavLink>
                    </Menu.Item>
                    <Menu.Item key='16'>
                        <NavLink to='product-list' className='link'>List Products</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='18' title="Subscription Payment" icon={<MdPayment size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='19'>
                        <NavLink to='subscription-payment-form?mode=ADD' className='link'>Add Subscription Payment</NavLink>
                    </Menu.Item>
                    <Menu.Item key='20'>
                        <NavLink to='subscription-payment-list' className='link'>List Subscription Payments</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='21' title="Subscription Plan" icon={<FaCalendarDay size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='22'>
                        <NavLink to='subscription-plan-form?mode=ADD' className='link'>Add Subscription Plan</NavLink>
                    </Menu.Item>
                    <Menu.Item key='23'>
                        <NavLink to='subscription-plan-list' className='link'>List Subscription Plan</NavLink>
                    </Menu.Item>
                </SubMenu>
                
                <SubMenu key='24' title="Subscription" icon={<MdSubscriptions size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='25'>
                        <NavLink to='enterprise-subscription-form?mode=ADD' className='link'>Add Subscription</NavLink>
                    </Menu.Item>
                    <Menu.Item key='26'>
                        <NavLink to='enterprise-subscription-list' className='link'>List Subscription</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='27' title="Role" icon={<FaUserCog size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='28'>
                        <NavLink to='role-form?mode=ADD' className='link'>Add Role</NavLink>
                    </Menu.Item>
                    <Menu.Item key='29'>
                        <NavLink to='role-list' className='link'>List Roles</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='30' title="User" icon={<FaUserAlt size='20px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='31'>
                        <NavLink to='user-form?mode=ADD' className='link'>Add User</NavLink>
                    </Menu.Item>
                    <Menu.Item key='32'>
                        <NavLink to='user-list' className='link'>List Users</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='33' title="Role Privilege" icon={<FaUsersCog size='25px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='34'>
                        <NavLink to='role-privilege-form?mode=ADD' className='link'>Add Role Privilege</NavLink>
                    </Menu.Item>
                    <Menu.Item key='35'>
                        <NavLink to='role-privilege-list' className='link'>List Role Privileges</NavLink>
                    </Menu.Item>
                </SubMenu>

                <SubMenu key='36' title="API User" icon={<FaUserAlt size='20px' style={{marginRight: '1rem'}} />}>
                    <Menu.Item key='37'>
                        <NavLink to='api-user-form?mode=ADD' className='link'>Add API User</NavLink>
                    </Menu.Item>
                    <Menu.Item key='38'>
                        <NavLink to='api-user-list' className='link'>List API User</NavLink>
                    </Menu.Item>
                </SubMenu>

                
            </Menu>
        </Wrapper>
    );
}

export default SideNav;

const Wrapper = styled.div`
    flex: 1;
    ::-webkit-scrollbar {
        width: 2.5px;
    }
    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${({theme}) => theme.colors.secondary};
        outline: 1px solid slategrey;
        border-radius: 1.5px;
    }
    background: ${({theme}) => theme.colors.primary};
    .link {
        text-decoration: none;
    }
    .ant-menu-submenu-title {
    }
    .ant-menu-submenu-active, .ant-menu-submenu-title {
        color: #fff!important;
      }
    .ant-menu-submenu-title:hover {
        color: #fff!important;
        border-radius: 0;
    }
    .ant-menu-submenu-arrow::before, .ant-menu-submenu-arrow::after {
        background: ${({theme}) => theme.colors.secondary};
        color: #fff!important;
    }
    .ant-menu-item::before, .ant-menu-item::after {
        background: ${({theme}) => theme.colors.primary};
        color: #fff!important;
    }
    .ant-menu-item:hover {
        color: #fff!important;
        border-radius: 0;  
    }
    
    .ant-menu-item-selected {
        background-color: #1C79BB !important;
        ${'' /* color: #fff!important; */}
        color: #9ccff5!important;
    }
    .ant-menu-submenu-item-selected {
        margin-left: 20px;
    }
`;
